var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    fill: "#EAEFFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2717 5.15691C12.0625 4.9477 11.7233 4.9477 11.5141 5.15691C11.3048 5.36612 11.3048 5.70531 11.5141 5.91452L12.7424 7.14286H6.53571C6.23985 7.14286 6 7.3827 6 7.67857C6 7.97444 6.23985 8.21429 6.53571 8.21429H12.7424L11.5141 9.44262C11.3048 9.65183 11.3048 9.99103 11.5141 10.2002C11.7233 10.4094 12.0625 10.4094 12.2717 10.2002L14.4145 8.05738C14.6237 7.84817 14.6237 7.50897 14.4145 7.29976L12.2717 5.15691ZM9.05738 10.5574C9.26659 10.3482 9.26659 10.009 9.05738 9.79976C8.84817 9.59056 8.50897 9.59056 8.29976 9.79976L6.15691 11.9426C6.05644 12.0431 6 12.1793 6 12.3214C6 12.4635 6.05644 12.5998 6.15691 12.7002L8.29976 14.8431C8.50897 15.0523 8.84817 15.0523 9.05738 14.8431C9.26659 14.6339 9.26659 14.2947 9.05738 14.0855L7.82904 12.8571H14.0357C14.3316 12.8571 14.5714 12.6173 14.5714 12.3214C14.5714 12.0256 14.3316 11.7857 14.0357 11.7857H7.82904L9.05738 10.5574Z",
    fill: "#2E5CF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplaceIcon);
export default __webpack_public_path__ + "static/media/replace-icon.5bda8c28.svg";
export { ForwardRef as ReactComponent };